export const odpPlaceholderMetric = {
  name: 'placeholder-metric',
  displayName: 'Placeholder Metric',
  ovbDisplayName: 'Placeholder Metric',
  short: 'Placholder',
  ovbShort: 'Placholder',
  subscript: '',
  active: true,
  calcPercentage: false,
  unit: '',
  sortBy: false,
  helpText: 'This is a placeholder metric, click on the metric popup to add/remove metrics',
  category: 'Startup Experience',
  type: 'odpMetric',
};

export const defaultDimensionGroupBy = 'ODP_PLACEHOLDER_DIMENSION';
